"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4453],{

/***/ 94453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_Testimonial; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./components/core/Typography/Typography.tsx
var Typography = __webpack_require__(44718);
;// CONCATENATED MODULE: ./components/sections/Testimonial/testimonial.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 5rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 7.5rem;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-wrap: nowrap;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 7.5rem;\n    padding-bottom: 8.75rem;\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 4rem;\n  "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 3.5rem;\n    width: 3.5rem;\n    min-width: 3.5rem;\n    min-height: 3.5rem;\n    border-radius: 3.5rem;\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-left: 1rem;\n  "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 1.5rem;\n  "
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 1rem;\n    line-height: 2rem;\n  "
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    letter-spacing: 0;\n  "
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        ";\n    font-weight: 400;\n  "
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: left;\n    margin-bottom: 4rem;\n    font-size: 3rem;\n    line-height: 3.5rem;\n  "
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 1.125rem;\n    line-height: 2.25rem;\n    margin-top: 2rem;\n  "
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}
function _templateObject14() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: none;\n  "
    ]);
    _templateObject14 = function() {
        return data;
    };
    return data;
}
function _templateObject15() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: auto;\n  "
    ]);
    _templateObject15 = function() {
        return data;
    };
    return data;
}
function _templateObject16() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      min-width: 2.625rem;\n      min-height: 2rem;\n    "
    ]);
    _templateObject16 = function() {
        return data;
    };
    return data;
}
function _templateObject17() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n            margin-right: 1.5rem;\n            margin-bottom: 0;\n          "
    ]);
    _templateObject17 = function() {
        return data;
    };
    return data;
}
function _templateObject18() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          margin-bottom: 1rem;\n          ",
        ";\n          &:after {\n            left: 0;\n            top: 0;\n          }\n        "
    ]);
    _templateObject18 = function() {
        return data;
    };
    return data;
}
function _templateObject19() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n            margin-left: 1.5rem;\n            margin-top: 0;\n          "
    ]);
    _templateObject19 = function() {
        return data;
    };
    return data;
}
function _templateObject20() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          margin-top: 1rem;\n          ",
        ";\n          &:after {\n            bottom: 0;\n            right: 0;\n            transform: rotate(180deg);\n          }\n        "
    ]);
    _templateObject20 = function() {
        return data;
    };
    return data;
}




const Section = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "erbqngh0"
})("width:100%;position:relative;z-index:0;margin-bottom:4rem;", mixins.mq.small((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())), ";");
const Content = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "erbqngh1"
})("display:flex;justify-content:space-around;position:relative;flex-wrap:wrap;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())), ";");
const Inner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "erbqngh2"
})(mixins/* defaultContainerSize */.sX, ";padding-top:2.5rem;padding-bottom:5rem;", mixins.mq.small((0,emotion_react_browser_esm/* css */.iv)(_templateObject3())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject4())), ";");
const Author = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "erbqngh3"
})("display:flex;margin-top:1.5rem;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject5())), ";");
const AuthorPicture = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "erbqngh4"
})("height:3rem;width:3rem;min-width:3rem;min-height:3rem;border-radius:3rem;position:relative;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject6())), ";");
const AuthorDetails = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "erbqngh5"
})("margin-left:0.75rem;display:flex;flex-wrap:wrap;", mixins.mq.small((0,emotion_react_browser_esm/* css */.iv)(_templateObject7())), ";");
const AuthorName = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "erbqngh6"
})("margin:0;font-size:1.25rem;line-height:2rem;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";flex:0 0 100%;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject8())), ";");
const AuthorPosition = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "erbqngh7"
})("margin:0;font-size:0.75rem;line-height:0.875rem;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.nunito;
}, ";font-weight:300;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.darker_grey;
}, ";flex:0 0 100%;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject9())), ";");
const Paragraph = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "erbqngh8"
})(Typography/* ParagraphM */.Sl, ";font-weight:400;margin:0;letter-spacing:0.0125rem;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject10())), ";", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject11(), Typography/* ParagraphL */.q9)), ";");
const Bold = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "erbqngh9"
})("font-weight:700;");
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h3", {
    target: "erbqngh10"
})(Typography/* Header2 */.zV, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";margin:0 0 1rem 0;display:block;text-align:center;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject12())), ";");
const Button = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "erbqngh11"
})("position:relative;z-index:999;align-self:flex-start;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.nunito;
}, ";font-weight:300;font-size:1rem;line-height:1.5rem;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.grey;
}, ";text-decoration:underline;background:transparent;border:none;margin-top:1rem;padding:0.5rem 0;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject13())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject14())), ";");
const QuoteIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "erbqngh12"
})("min-width:2.625rem;min-height:2rem;position:relative;width:100%;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject15())), ";&:after{content:'';background:url(\"data:image/svg+xml,%3Csvg width='37' height='28' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M28.2095 14.7778c0 1.3827.8627 2.8518 2.588 4.4074 1.7254 1.5555 2.5881 2.5926 2.5881 3.1111 0 3.8025-1.8117 5.7037-5.4349 5.7037-2.0704 0-3.9683-.6049-5.6937-1.8148-1.7253-1.3827-2.588-3.4568-2.588-6.2222 0-2.9383 1.5528-7 4.6585-12.18522C27.6056 2.59259 31.4014 0 35.7148 0c.6901 0 1.0352.172841 1.0352.51852-5.6937 5.7037-8.5405 10.45678-8.5405 14.25928zm-19.66901-.2593c0 1.3827.86268 2.8519 2.58801 4.4074 1.7254 1.5556 2.588 2.679 2.588 3.3704 0 3.8025-1.8978 5.7037-5.69361 5.7037-2.07043 0-3.96831-.6049-5.69366-1.8148C.776409 24.9753 0 22.9012 0 19.963c0-2.9383 1.63908-7 4.91725-12.18522C8.19542 2.59259 11.8187 0 15.787 0c.6901 0 1.0352.259259 1.0352.777776C11.3011 7 8.54049 11.5802 8.54049 14.5185z' fill='%23212121'/%3E%3C/svg%3E\")\n      no-repeat center center;min-width:2rem;min-height:1.5rem;background-size:100% 100%;position:absolute;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject16())), ";}", (param)=>{
    let { type  } = param;
    switch(type){
        case "left":
            return (0,emotion_react_browser_esm/* css */.iv)(_templateObject18(), mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject17())));
        case "right":
            return (0,emotion_react_browser_esm/* css */.iv)(_templateObject20(), mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject19())));
    }
});

;// CONCATENATED MODULE: ./utils/htmlSerializers/testimonialHtmlSerializer.ts



const propsWithUniqueKey = (props, key)=>Object.assign(props || {}, {
        key
    });
// TODO: type of this function
const testimonialHtmlSerializer = (type, element, content, children, key)=>{
    let props = {};
    switch(type){
        case prismic_reactjs.Elements.paragraph:
            props = {
                className: "testimonial__paragraph"
            };
            return react.createElement(Paragraph, propsWithUniqueKey(props, key), children);
        case prismic_reactjs.Elements.strong:
            props = {};
            return react.createElement(Bold, propsWithUniqueKey(props, key), children);
        default:
            return null;
    }
};

// EXTERNAL MODULE: ./utils/imageSerializer.ts
var imageSerializer = __webpack_require__(9790);
;// CONCATENATED MODULE: ./components/sections/Testimonial/Testimonial.tsx








const Testimonial = (param)=>{
    let { title , quote , additionalClassName , caseStudy , caseImage , caseName , casePosition , titleAs  } = param;
    const className = classnames_default()("testimonial", additionalClassName);
    const [isShowing, setIsShowing] = (0,react.useState)(false);
    const displayButton = (quote === null || quote === void 0 ? void 0 : quote.length) > 1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section, {
        className: className,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Inner, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                    as: titleAs,
                    children: title
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QuoteIcon, {
                            type: "left"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: classnames_default()("testimonial__quote", {
                                "testimonial__quote--show": isShowing
                            }),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(prismic_reactjs.RichText, {
                                    render: quote,
                                    htmlSerializer: testimonialHtmlSerializer
                                }),
                                displayButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button, {
                                    onClick: ()=>setIsShowing(!isShowing),
                                    children: isShowing ? "Less" : "More"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QuoteIcon, {
                            type: "right"
                        })
                    ]
                }),
                caseStudy ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Author, {
                    className: "short-testimonial__author",
                    children: [
                        caseImage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AuthorPicture, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                ...(0,imageSerializer/* imageSerializer */.l)(caseImage)
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AuthorDetails, {
                            className: "author__details",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AuthorName, {
                                    className: "author__name",
                                    children: caseName
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AuthorPosition, {
                                    className: "author__position",
                                    children: casePosition
                                })
                            ]
                        })
                    ]
                }) : null
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/sections/Testimonial/index.ts

/* harmony default export */ var sections_Testimonial = (Testimonial);


/***/ })

}]);